import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getTheoryCourses = (state) => state.theoryCourses;
export const getLicenceClasses = (state) => state.licenceClasses;
export const getDrivingSchool = (state) => state.drivingSchool;
export const getBranches = (state) => state.branches;
export const getLanguages = (state) => state.languages;
export const getLanguagesLoading = (state) => state.languagesLoading;
export const getLanguagesError = (state) => state.languagesError;
export const getCountries = (state) => state.countries;
export const getCountriesLoading = (state) => state.countriesLoading;
export const getCountriesError = (state) => state.countriesError;
export const getPreviousLicenceClassesError = (state) => state.previousLicenceClassesError;
export const getPreviousLicenceClassesLoading = (state) => state.previousLicenceClassesLoading;
export const getPreviousLicenceClasses = (state) => state.previousLicenceClasses;
export const getSelectedLicenseClass = (state) => state.selectedLicenseClass;
export const getSelectedTheoryCourse = (state) => state.selectedTheoryCourse;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getTheoryCourses,
    getLicenceClasses,
    getDrivingSchool,
    getBranches,
    getLanguages,
    getLanguagesLoading,
    getLanguagesError,
    getCountries,
    getCountriesLoading,
    getCountriesError,
    getPreviousLicenceClassesError,
    getPreviousLicenceClassesLoading,
    getPreviousLicenceClasses,
    getSelectedLicenseClass,
    getSelectedTheoryCourse,
};
